import React from 'react';
import {
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Checkbox,
  Typography,
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import tableStyles from '../table-styles';
import { HeadCell } from './expandable-row';

type Order = 'asc' | 'desc';

interface EnhancedTableProperties {
  classes: ReturnType<typeof tableStyles>;
  numSelected: number;
  onRequestSort: (event: React.MouseEvent<unknown>, property: keyof any) => void;
  onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  order: Order;
  orderBy: string;
  rowCount: number;
  headCells: HeadCell[];
  selectableRows?: Function;
  expandableDataExists: boolean;
  isDownloadable?: boolean;
}

const EnhancedTableHead = (properties: EnhancedTableProperties) => {
  const {
    classes,
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
    headCells,
    selectableRows,
    expandableDataExists,
    isDownloadable,
  } = properties;
  const createSortHandler = (property: keyof any) => (event: React.MouseEvent<unknown>) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {selectableRows !== undefined ? (
          <TableCell padding="checkbox" className={classes.headerCell}>
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              onChange={onSelectAllClick}
              inputProps={{
                'aria-label': 'select all',
              }}
            />
          </TableCell>
        ) : (
          <></>
        )}
        {headCells.map((headCell: any) => (
          <TableCell
            className={classes.headerCell}
            key={headCell.id}
            align="center"
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              className={classes.headerLabel}
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
              IconComponent={ExpandMore}
            >
              <Typography variant="h6"> {headCell.label}</Typography>
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : (
                <></>
              )}
            </TableSortLabel>
          </TableCell>
        ))}
        {expandableDataExists && <TableCell className={classes.headerCell} />}
        {isDownloadable && <TableCell className={classes.headerCell} />}
      </TableRow>
    </TableHead>
  );
};

export default EnhancedTableHead;
